import { ButtonClean, Input } from '@fourthwall/components';
import React, { useMemo } from 'react';
import { useNewPodcastModalContext } from '../../hooks/useNewPodcastModalContext';
import { Preview } from '../Preview/Preview';
import { SpotifyUrlHelp } from '../SpotifyUrlHelp/SpotifyUrlHelp';
import * as S from './ExistingPodcastFields.styled';
export const ExistingPodcastFields = () => {
    const { existingPodcastForm, preview, isLoading } = useNewPodcastModalContext();
    const previewError = useMemo(() => {
        if (preview.error)
            return 'Please provide a correct Spotify podcast URL';
        if (preview.data?.hostedOnSpotify)
            return (React.createElement("p", null,
                "This feature is not yet available for podcasts hosted on Spotify (though Spotify says they are working on adding support). Instead, you can create a new podcast for your members-only audio on Spotify.",
                ' ',
                React.createElement(ButtonClean, { appearance: "destructive", label: "Learn more", href: "https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify#:~:text=Warning%3A%20If%20your%20podcast%20is%20hosted", target: "_blank" })));
        return existingPodcastForm.errors.url;
    }, [preview.error, preview.data?.hostedOnSpotify, existingPodcastForm.errors.url]);
    return (React.createElement(S.Container, null,
        React.createElement(Input, { label: "Spotify URL of your podcast", disabled: isLoading, ...existingPodcastForm.getFieldProps('url'), error: previewError }),
        !preview.data && React.createElement(SpotifyUrlHelp, null),
        preview.data && (React.createElement(Preview, { title: preview.data.name, description: preview.data.description, artworkUrl: preview.data.imageUrl }))));
};
